// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export enum IssuesResponsibilityCategoryEType {
  RSC = 'rsc',
  CUSTOMER = 'customer',
  UNKNOWN = 'unknown',
}
